import { Component } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../../../../../core/animations';

//Local files
import { userInfo, skills, skillDropdown, skillRadio } from '../../../../../../../../../utils/index';

import { SideNavService } from '../../../../../../sidenav.service';

@Component({
    selector: 'skills',
    templateUrl: './skills.component.html',
    styleUrls: ['./skills.component.scss'],
    animations: fuseAnimations
})

export class SkillsComponent {

    userInfo = userInfo;
    skills = skills;
    skillDropdown = skillDropdown;
    skillRadio = skillRadio;

    skillData: any;

    onProUserInfoTabSelectedSubscription: Subscription;

    constructor(
        public sideNavService: SideNavService
    ) {
    }

    ngOnInit() {

        this.onProUserInfoTabSelectedSubscription =
            this.sideNavService.onProUserInfoTabSelected.subscribe(data => {

                var user = data;

                if (user) {

                    this.skillData = {
                        "roughCarpentry": user.roughCarpentry,
                        "finishCarpentry": user.finishCarpentry,
                        "plumbing": user.plumbing,
                        "electrical": user.electrical,
                        "hvac": user.hvac,
                        "exteriorRoofingSidingGutters": user.exteriorRoofingSidingGutters,
                        "sheetrockInstall": user.sheetrockInstall,
                        "sheetrockFinish": user.sheetrockFinish,
                        "paint": user.paint,
                        "appliances": user.appliances,
                        "handymanWork": user.handymanWork,
                        "kitchenRemodeling": user.kitchenRemodeling,
                        "bathroomRemodeling": user.bathroomRemodeling,
                        /** radio button */
                        "roughRadio": user.roughRadio,
                        "finishRadio": user.finishRadio,
                        "plumbingRadio": user.plumbingRadio,
                        "electricalRadio": user.electricalRadio,
                        "hvacRadio": user.hvacRadio,
                        "exteriorRadio": user.exteriorRadio,
                        "sheetrockInstallRadio": user.sheetrockInstallRadio,
                        "sheetrockFinishRadio": user.sheetrockFinishRadio,
                        "paintRadio": user.paintRadio,
                        "appliancesRadio": user.appliancesRadio,
                        "handymanWorkRadio": user.handymanWorkRadio,
                        "kitchenRemodelingRadio": user.kitchenRemodelingRadio,
                        "bathroomRemodelingRadio": user.bathroomRemodelingRadio,

                    };

                }

            })
    }

    ngDestroy() {
        this.onProUserInfoTabSelectedSubscription.unsubscribe();

    }

    // Get display value of selected dropdown value
    getDisplayValue(fromArray, proficiency) {
        var result = _.find(fromArray, { 'key': proficiency });
        return result ? result.label : '-';
    }

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/skills/skills.component.ts